/**
 * Cache module-level des stakeholders par feuille (survit aux recréations ProcessManager).
 * Clé : `${mapId}::${blockText}` — alignée sur ProcessManager.stakeholderCacheKey.
 */
const store = new Map<string, string[]>();

export function stakeholderCacheKey(mapId: string, blockText: string): string {
  return `${mapId}::${blockText || ''}`;
}

export function getStakeholderCache(key: string): string[] | undefined {
  return store.get(key);
}

export function setStakeholderCache(key: string, stakeholders: string[]): void {
  store.set(key, stakeholders);
}

export function hasStakeholderCacheForMap(mapId: string): boolean {
  if (!mapId?.trim()) return false;
  const prefix = `${mapId}::`;
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) return true;
  }
  return false;
}

export function invalidateStakeholderCacheForMap(mapId: string): void {
  if (!mapId?.trim()) return;
  const prefix = `${mapId}::`;
  for (const key of store.keys()) {
    if (key.startsWith(prefix)) store.delete(key);
  }
}

export function clearStakeholderCacheStore(): void {
  store.clear();
}

/** Exposé pour tests unitaires uniquement. */
export function _stakeholderCacheSize(): number {
  return store.size;
}
